import React, { useState } from "react";
import AddNewContactFunctional from "./AddNewContactFunctional";
import ModalNewUI from "../../../components/ui/Modals/ModalMessages/ModalNewUI";
const NewAddNewContactButton = (props) => {
	const [addContactMenu, setAddContactMenu] = useState(false);

	const showAddContact = () => setAddContactMenu(true);
	const closeAddContact = () => setAddContactMenu(false);

	let userDomain = props.selectedDomain?.userDomain || "";

	return (
		<React.Fragment>
			{/* <Stack flexDirection='row' justifyContent='center' sx={{ pt: 3, pb: 5 }}>
				<Button variant="contained"
					onClick={showAddContact}
					sx={{
						padding: '0.3rem 1.4rem',
						textTransform: 'capitalize',
						backgroundColor: "#376AFA",
						borderRadius: "0.5rem",
						fontFamily: "Figtree-Regular", 
						fontWeight:"600",
						fontSize: "13px",
						'&:hover': {
							backgroundColor: '#376AFA'
						}
					}}
				>
					
					Send Invite
				</Button>
			</Stack> */}

			{addContactMenu && (
				<ModalNewUI
					onClose={closeAddContact}
					open={addContactMenu}
					headerContent={<div style={{ fontSize: '16px'}}>Add new contact</div>}
                    customDialogStyles={{width:'850px', maxWidth:'1200px' , height:'650px', maxHeight:'700px', overflowY:'hidden'}}
				>
					<AddNewContactFunctional
						{...props}
						cancel={closeAddContact}
						selectedTabFromParent="emailInvite"
						fetchContacts={(data) => {
							props.fetchContacts(data, true);
						}}
					/>
				</ModalNewUI>
			)}
		</React.Fragment>
	);
};

export default NewAddNewContactButton;
